module.exports = __webpack_public_path__ + "static/media/parts-bg-smoke.94a67739.png";